import { render, staticRenderFns } from "./GroupInformationAboutStudentMovementReport.vue?vue&type=template&id=1c8038d4&"
import script from "./GroupInformationAboutStudentMovementReport.vue?vue&type=script&lang=js&"
export * from "./GroupInformationAboutStudentMovementReport.vue?vue&type=script&lang=js&"
import style0 from "./GroupInformationAboutStudentMovementReport.vue?vue&type=style&index=0&id=1c8038d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports